import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/analyse",
    name: "analyse",
    component: () => import("../views/AnalyseView.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () => import("../views/ProductView.vue"),
  },
  {
    path: "/technology",
    name: "technology",
    component: () => import("../views/TechnologyView.vue"),
  },
  {
    path: "/demand",
    name: "demand",
    component: () => import("../views/DemandView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
  {
    path: "/xiazai",
    name: "xiazai",
    component: () => import("../views/XiaZaiView.vue"),
  },
];

const router = new VueRouter({
  mode: "hash", // 使用 hash 模式，支持直接打开文件
  routes,
});

export default router;
